import { useNavigate } from 'react-router-dom';
import { Button, Tooltip } from '@chakra-ui/react';


const ViewInsightsButton = ({ text, isDisabled, ...props }) => {
    const navigate = useNavigate();

    return (
        <Tooltip
            label="Add journeys to access insights"
            isDisabled={!isDisabled}
            hasArrow
        >
            <Button
                onClick={() => navigate('/myjourneys/insights')}
                isDisabled={isDisabled}
                variant="outline"
                {...props}
            >
                { text ? text : 'View insights'}
            </Button>
        </Tooltip>
    );
};

export default ViewInsightsButton;